module.exports = __webpack_public_path__ + "img/notification-dog.176d9146.png";